import { useNode } from '@craftjs/core';
import { cn } from '../../../../lib/utils';

interface SpacerBlockProps {
  height: number;
}

export function SpacerBlock({ height }: SpacerBlockProps) {
  const {
    connectors: { connect, drag },
    selected,
  } = useNode((state) => ({
    selected: state.events.selected,
  }));

  return (
    <div
      ref={(ref) => {
        if (ref) connect(drag(ref));
      }}
      className={cn(
        'w-full rounded transition-all',
        selected && 'ring-2 ring-primary ring-offset-2 bg-primary/5'
      )}
      style={{ height: `${height}px` }}
      aria-hidden="true"
    >
      {selected && (
        <div className="flex items-center justify-center h-full text-xs text-muted-foreground">
          Espaço — {height}px
        </div>
      )}
    </div>
  );
}

SpacerBlock.craft = {
  displayName: 'Espaço',
  props: {
    height: 40,
  },
  rules: { canDrag: () => true },
};
